import * as React from "react";
import styled, { css } from "styled-components";

import { theme } from "./theme";

const LoadingWrapper = styled.div<{ size: number }>`
  ${({ size }) => css`
    /* stylelint-disable-next-line at-rule-prelude-no-invalid */
    @keyframes lds-ellipsis1-${size} {
      0% {
        transform: scale(0);
      }
      100% {
        transform: scale(1);
      }
    }
    /* stylelint-disable-next-line at-rule-prelude-no-invalid */
    @keyframes lds-ellipsis3-${size} {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(0);
      }
    }
    /* stylelint-disable-next-line at-rule-prelude-no-invalid */
    @keyframes lds-ellipsis2-${size} {
      0% {
        transform: translate(0, 0);
      }
      100% {
        transform: translate(${size * 1.7}px, 0);
      }
    }
    display: inline-block;
    position: relative;
    width: ${size * 5.8}px;
    height: ${size}px;
    z-index: 0;
    div {
      position: absolute;
      width: ${size}px;
      height: ${size}px;
      border-radius: 50%;
      background: ${theme.blue};
      animation-timing-function: cubic-bezier(0, 1, 1, 0);
      &:nth-child(1) {
        left: ${size / 2}px;
        animation: 0.6s lds-ellipsis1-${size} 0.6s infinite;
      }
      &:nth-child(2) {
        left: ${size / 2}px;
        animation: 0.6s lds-ellipsis2-${size} 0.6s infinite;
      }
      &:nth-child(3) {
        left: ${size * 2.3}px;
        animation: 0.6s lds-ellipsis2-${size} 0.6s infinite;
      }
      &:nth-child(4) {
        left: ${size * 4}px;
        animation: 0.6s lds-ellipsis3-${size} 0.6s infinite;
      }
    }
  `}
`;

const FlexLoadingContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
`;

const LoadingComponent = (props: { size: number }) => (
  <LoadingWrapper size={props.size}>
    <div />
    <div />
    <div />
    <div />
  </LoadingWrapper>
);

const CenterLoading = (props: { size?: number; className?: string }) => (
  <FlexLoadingContainer data-test="center-loading-container" {...props}>
    <LoadingComponent size={props.size || 11} />
  </FlexLoadingContainer>
);

export const Loading = styled(CenterLoading)<{ color?: string }>`
  overflow: hidden;
  ${LoadingWrapper} {
    div {
      background: ${(props) => props.color || theme.blue};
    }
  }
`;
